import NewUlcdSelect from './src/main';

/* istanbul ignore next */
NewUlcdSelect.install = function(Vue) {
  Vue.component(NewUlcdSelect.name, NewUlcdSelect);
};

export default NewUlcdSelect;
